import React, { memo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../../assets/sass/uiV3/component/worldcup2023/_worldcup2023.scss';
import LazyImage from '../../CustomLibraries/LazyImage';
import InView from 'react-intersection-observer';
import { useTrackUserActivity } from '../../customHooks/useTrackUserActivity';

function LiveWorldCupScoreCTA({ logo, page_id = 0, id = 0 }) {
  const sponsor_logo = logo ? logo.split(',') : [];
  const { userActivityTracker } = useTrackUserActivity();
  function handleChange(inView) {
    userActivityTracker(inView, { type: 'iframe', type_id: id }, 'cta', page_id);
  }

  return (
    <InView
      as="div"
      id="floatCrictimes"
      className="d-flex rounded flex-column worldcup2023ScoreBoard"
      onChange={(inView) => handleChange(inView)}
    >




      <div className="rounded bg-black bg-opacity-25 d-flex justify-content-between align-items-center w-100 px-4 py-3">
        <h2 className="fs-2 text-white pe-3 fw-semibold m-0">Scoreboard</h2>

        {sponsor_logo && sponsor_logo?.length > 0 ? (
          <Swiper
            className="clr_v3_sponsor text-right me-0"
            navigation={false}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 2500
            }}
            effect={'fade'}
          >
            {sponsor_logo &&
              sponsor_logo?.length > 1 &&
              sponsor_logo?.map((_sp, idx) => (
                <SwiperSlide key={idx + 1} className="clr_v3_sponsor_slide w-100 position-relative">
                  <LazyImage
                    src={_sp}
                    alt="sponsor"
                    className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50 rounded m-0 text-center bg-white p-1`}
                    logo
                  />
                </SwiperSlide>
              ))}
            {sponsor_logo &&
              sponsor_logo?.length == 1 &&
              sponsor_logo?.map((_sp, idx) => (
                <div key={idx + 1} className="clr_v3_sponsor_slide w-100 position-relative">
                  <LazyImage
                    src={sponsor_logo[0]}
                    alt="sponsor"
                    className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50 rounded m-0 text-center bg-white p-1`}
                    logo
                  />
                </div>
              ))}
          </Swiper>
        ) : (
          <div className="clr_v3_sponsor_slide w-100 position-relative"></div>
        )}
      </div>
      <div className="py-50 position-relative overflow-hidden">
        <iframe
          id="iframe"
          src="https://dwidget.crictimes.org/index.html"
          frameborder="0"
          scrolling="no"
        ></iframe>
        <div
          className="overlay"
        // style={{ height: '100px', width: '109%', marginLeft: '-10px' }}
        ></div>
      </div>

    </InView>
  );
}

export default memo(LiveWorldCupScoreCTA);
